import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CasesQueryParams,
  PaginatedCasesResult,
  VersionHistoryEntry,
  TraceabilityMetrics,
  TraceabilityMetricsFilterParams
} from '@model/traceability/traceability.model';
import { ITraceabilityQueryPort } from '@domain/service/traceability/traceability-query.port';
import { TraceabilityService } from '../services/traceability.service';

@Injectable({
  providedIn: 'root'
})
export class TraceabilityQueryAdapter implements ITraceabilityQueryPort {
  private readonly traceabilityService = inject(TraceabilityService);

  getSamples(params?: CasesQueryParams): Observable<PaginatedCasesResult> {
    return this.traceabilityService.getSamples(params);
  }

  getVersionHistory(identifier: string): Observable<VersionHistoryEntry[]> {
    return this.traceabilityService.getCaseHistory(identifier).pipe(
      map((auditLogs) =>
        this.traceabilityService.transformToVersionHistory(auditLogs)
      )
    );
  }

  getMetrics(params?: TraceabilityMetricsFilterParams): Observable<TraceabilityMetrics> {
    return this.traceabilityService.getMetrics(params);
  }

  getMetricsStream(
    params?: TraceabilityMetricsFilterParams,
    intervalMs?: number
  ): Observable<TraceabilityMetrics> {
    return this.traceabilityService.getMetricsStream(params, intervalMs);
  }

  exportSamplesToCSV(params?: CasesQueryParams): Observable<Blob> {
    return this.traceabilityService.exportSamplesToCSV(params);
  }
}
